export const SUCCESS_REDIRECT = 'https://store.google.com/jp/category/phones?hl=ja?utm_source=sheerid&utm_medium=partner&utm_campaign=GS107441&utm_content=website&promoCode=';
export const PENDING_REDIRECT = 'https://store.google.com/jp/category/phones';
export const PRIVACY_POLICY = 'https://policies.google.com/privacy?hl=ja';
